import styled from 'styled-components';

const Wrapper = styled.div`
  left: ${({popoverLeft}) => `${popoverLeft}px !important`};
  bottom: ${({popoverBottom}) => `${popoverBottom}px !important`};
`;
export default Wrapper;
